module.exports = __webpack_public_path__ + "img/job-count-bg.c7673832.png";